import _ from 'lodash';

const getResponseErrorMessage = (e, message = '') =>
  `${message} ${_.get(e, 'error.detail') || _.get(e, 'message') || ''}`;

export default getResponseErrorMessage;
